import {XCol, XPlainButton, XText} from "@cdx/common";
import {useModalWithData} from "../../components/Modals";
import {useLocalStorageState} from "../../lib/storage";

const AgeProtection = () => {
  const [isAdult, setIsAdult] = useLocalStorageState(`openProject.isAdult`);

  const renderModal = useModalWithData(!isAdult, {hideClose: true, blurBackdrop: true});

  return renderModal(() => (
    <XCol pa={3} sp={5} py={5} align="center">
      <XText as="h2" preset="bold" size={4} align="center">
        You must be 18+ to view this Open Deck
      </XText>
      <XText align="center">
        This Open Deck contains adult content so we require this age check:
      </XText>
      <XPlainButton size="xl" color="purple" onClick={() => setIsAdult(true)}>
        I confirm that I'm 18 or older
      </XPlainButton>
    </XCol>
  ));
};

export default AgeProtection;
